



















































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { SearchResponse } from '@empathybroker/tsclient-search';

import { mapActions } from 'vuex';

import { CrudForm, RegularFilterSelector, TagsInput } from '../../components';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { SEARCH_CONSTS } from '../../store/search/search.consts';

export default {
  name: 'boosts-form',
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    RegularFilterSelector,
    TagsInput
  },
  computed: {
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config.mandatory = true;
      return filters;
    },
    valid: function (): boolean {
      if (!this.item.filters.lang.length) {
        return false;
      }
      if (!this.item.queries.length) {
        return false;
      }
      if (!this.item.products.length) {
        return false;
      }
      return true;
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.BOOST,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.boosts.update),
      item: {
        enabled: true,
        queries: [],
        products: [],
        filters: {
          lang: []
        },
        schedule: {
          activationDate: null,
          deactivationDate: null
        }
      },
      messages: this.$epb.messages.tools.boosts,
      searchProductsResponse: undefined,
      searchProductIdsResponse: []
    };
  },
  methods: {
    ...mapActions(SEARCH_CONSTS.moduleName, {
      search: SEARCH_CONSTS.actions.search
    }),
    searchProductsByQuery: async function (query: string) {
      this.searchProductsResponse = undefined;
      this.loading.search = false;
      if (!!query) {
        this.loading.search = true;
        try {
          this.searchProductsResponse = await this.search({
            filters: {
              lang: this.filters.lang
            },
            pagination: {
              page: 1,
              itemsPerPage: 20
            },
            query: query,
            boost: true
          });
        } catch (error) {
          // TODO error handling on searchProductsByQuery
        } finally {
          this.loading.search = false;
        }
      }

    },
    searchProductsByIds: async function (productIds) {
      try {
        this.searchProductIdsResponse = await Promise.all((productIds.map((productId: string) => this.search({
          filters: {
            lang: this.filters.lang
          },
          pagination: {
            page: 1,
            itemsPerPage: 1
          },
          query: productId,
          boost: true
        })) as SearchResponse[]));
      } catch (error) {
        // TODO error handling on searchProductsById
      } finally {
        // TODO loading handling on searchProductsById
      }
    }
  }
};

